export class Currency {
    public constructor(
        public code: string,
        public displayName: string,
        // E.g. JPY, see https://support.stripe.com/questions/which-zero-decimal-currencies-does-stripe-support
        // eslint-disable-next-line @typescript-eslint/no-shadow
        public isZeroDecimal: boolean,
        public symbol?: string,
    ) {}
}

export const CURRENCY_USD = new Currency('USD', 'United States Dollar', false, '$');

export const CURRENCIES: ReadonlyArray<Currency> = Object.freeze([
    new Currency('AUD', 'Australian Dollar', false, '$'),
    new Currency('CAD', 'Canadian Dollar', false, '$'),
    new Currency('DOP', 'Dominican Peso', false, 'RD$'),
    new Currency('EUR', 'Euro', false, '\u20AC'),
    new Currency('GBP', 'United Kingdom Pound', false, '\u00A3'),
    new Currency('HKD', 'Hong Kong Dollar', false, '$'),
    new Currency('INR', 'Indian Rupee', false, '\u20B9'),
    new Currency('KRW', 'South Korean Won', true, '\u20A9'),
    new Currency('NZD', 'New Zealand Dollar', false, '$'),
    new Currency('TWD', 'New Taiwan Dollar', false, 'NT$'),
    new Currency('MMK', 'Kyat', false, 'K'),
    new Currency('JPY', 'Japanese Yen', true, '\u00A5'),
    new Currency('SGD', 'Singapore Dollar', false, 'S$'),
    CURRENCY_USD,
]);

export function findCurrency(code: string): Currency | null {
    if (!code) {
        return null;
    }
    for (const currency of CURRENCIES) {
        if (currency.code === code) {
            return currency;
        }
    }
    return null;
}

export function findCurrencyWithDefault(code: string, defaultCurrency: Currency): Currency {
    return findCurrency(code) || defaultCurrency;
}

export function isZeroDecimal(code: string): boolean {
    if (!code) {
        return false;
    }
    const currency = findCurrency(code);
    return currency ? currency.isZeroDecimal : false;
}

export function getCurrencyString(
    amountInCents: number,
    currencyCode: string,
    locale: string | undefined,
    omitCode?: boolean,
): string {
    const currency = findCurrency(currencyCode);
    let formatter = new Intl.NumberFormat(locale);

    if (currency) {
        formatter = new Intl.NumberFormat(locale, { currency: currencyCode, style: 'currency' });
    } else {
        formatter = new Intl.NumberFormat(locale, { maximumFractionDigits: 2, style: 'decimal' });
    }

    if (omitCode) {
        return formatter.format(amountInCents / 100);
    } else {
        return `${formatter.format(amountInCents / 100)} ${currencyCode}`;
    }
}
